import { cn } from '../../utils';
import type { ScheduleHouseChip } from './session-schedule-types';

/**
 * The session schedule's filter row — admin port of
 * `apps/auction/.../components/ScheduleFilterBar.tsx`, house chips only.
 *
 * The web original also renders an "only my bids" toggle; that concept has no
 * meaning for the admin operator (there is no "my bids" to filter by), so it
 * is dropped entirely rather than disabled or hidden.
 */

interface SessionFilterBarProps {
  houses: ScheduleHouseChip[];
  onToggleHouse: (_key: string) => void;
}

export function SessionFilterBar({ houses, onToggleHouse }: SessionFilterBarProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {houses.map((chip) => (
        <button
          key={chip.house.key}
          type="button"
          aria-pressed={chip.selected}
          onClick={() => onToggleHouse(chip.house.key)}
          className={cn(
            'inline-flex h-9 shrink-0 cursor-pointer items-center gap-2 rounded-full border px-3 text-[13px] font-medium whitespace-nowrap',
            chip.selected ? 'border-cf-ink bg-cf-ink text-white' : 'border-cf-line bg-cf-surface text-cf-ink',
          )}
        >
          <span aria-hidden="true" className="h-2 w-2 rounded-cf-xs" style={{ background: chip.color }} />
          {chip.house.shortName}
        </button>
      ))}
    </div>
  );
}
